import React from "react";
import cn from "classnames";
import Spring from "../Spring";
import styled from "styled-components";
import Loader from "../Loader";

interface IPageLoader { isFullPage?: boolean };

const Page = styled.div<IPageLoader>`
    overflow: hidden;
    background-color: ${p => p.theme.c.snow};
    min-height: calc(100vh - ${p => p.isFullPage ? 0 : 50}px);
    margin-top: ${p => p.isFullPage ? 0 : 50}px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default ({ isFullPage }: IPageLoader) => {
    if (isFullPage) {
        return (
            <Page isFullPage>
                <Loader />
            </Page>
        );
    }
    return (
        <Spring>
            <Page className={cn("spring--shadow", "spring--padding")}>
                <Loader />
            </Page>
        </Spring>
    );
};
